import { cn } from "helpers/classNames";
import { FC } from "react";

interface Props {
  label: string;
  name: string;
  disabled?: boolean;
  checked?: boolean;
  setChecked: (newValue: boolean) => void;
  small?: boolean;
  className?: string;
}
export const CheckboxStupid: FC<Props> = ({
  label,
  name,
  disabled = false,
  checked = false,
  setChecked,
  small,
  className,
}) => {
  return (
    <fieldset>
      <div className={cn("flex items-center", className)}>
        <div className="flex h-5 items-center">
          <input
            type="checkbox"
            name={name}
            className={cn(
              "rounded border-gray-300 text-cyan-600 focus:ring-cyan-400 disabled:text-gray-300",
              small ? "h-3.5 w-3.5" : "h-5 w-5",
            )}
            disabled={disabled}
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
          />
        </div>
        <div className="ml-3 text-sm">
          <label
            htmlFor={name}
            className={cn(
              "font-normal disabled:text-gray-400",
              small ? "text-sm text-gray-700" : "text-base text-gray-900",
            )}
            onClick={() => setChecked(!checked)}
          >
            {label}
          </label>
        </div>
      </div>
    </fieldset>
  );
};
